// Temporary server unavailability (a deploy restarts the backend: nginx answers
// 502 for a few seconds) must not surface as an error the client has to act on.
//
// Reads (GET/HEAD/OPTIONS) are retried with short backoff on 502/503/504 or a
// network error without a response. Writes are never retried automatically:
// a POST that reached the server before the restart could run twice. They get
// a message that says what happened and what to do.

export const RETRYABLE_STATUSES = Object.freeze([502, 503, 504]);
// About 6.5 s in total: covers a backend restart (measured 6-8 s on 2026-09-14).
export const RETRY_DELAYS_MS = Object.freeze([500, 1000, 2000, 3000]);

const IDEMPOTENT = ['get', 'head', 'options'];

export const isIdempotentMethod = (method) => IDEMPOTENT.includes(String(method || 'get').toLowerCase());

export const isTransientFailure = (error) => {
  if (!error || error.code === 'ERR_CANCELED' || error.__CANCEL__) return false;
  const status = error.response?.status;
  if (status) return RETRYABLE_STATUSES.includes(status);
  // No response at all: the connection failed (server restarting, network drop).
  return Boolean(error.request) || error.message === 'Network Error';
};

/** Delay before the next attempt, or null when the request must not be retried. */
export const nextRetryDelay = (config, error) => {
  if (!config || config.noRetry || !isIdempotentMethod(config.method) || !isTransientFailure(error)) {
    return null;
  }
  const delays = Array.isArray(config.retryDelays) ? config.retryDelays : RETRY_DELAYS_MS;
  const attempt = config.__retryCount || 0;
  return attempt < delays.length ? delays[attempt] : null;
};

export const temporaryUnavailableMessage = () => {
  let lang = 'ru';
  try {
    lang = localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'ru';
  } catch {
    // storage blocked: keep the default language
  }
  return lang === 'en'
    ? 'The server is temporarily unavailable (restarting). Please try again in a few seconds.'
    : 'Сервер временно недоступен (перезапуск). Повторите через несколько секунд.';
};
